import React, { useState } from 'react';

function App() {
  const [count, setCount] = useState(0);

  return (
    <div style={{ fontFamily: 'sans-serif', textAlign: 'center', marginTop: '15vh' }}>
      <h1>⚛️ React (Create React App)</h1>
      <p>Тестовый проект для проверки хостинга статики</p>
      <button
        onClick={() => setCount(c => c + 1)}
        style={{ fontSize: '1.2rem', padding: '0.5em 1.5em', cursor: 'pointer' }}
      >
        Счётчик: {count}
      </button>
      <p style={{ marginTop: '2em', color: '#888' }}>
        Если вы видите эту страницу — сборка и деплой прошли успешно ✅
      </p>
    </div>
  );
}

export default App;
